import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type PropsWithChildren, useState } from 'react'

import { ThemeProvider } from '../../shared/context/ThemeProvider'
import { AuthProvider } from '../../features/auth/state/AuthProvider'
import { createQueryClient } from '../queryClient'

export function AppProviders({ children }: PropsWithChildren) {
  const [queryClient] = useState(() => createQueryClient())

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          {children}
          {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
